module.exports = __webpack_public_path__ + "img/foclarity-logo-black-sm.bff1887f.png";